// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#CSScreen {
	position: absolute;
	top:0px;
	left:0px;
	width: 100vw;
	height: 100vh;
	right: 0px;
	bottom: 0px;
	background-color: rgba(0,0,0,0);
	z-index: 100;
}

#CSContainer{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    background-color: white;
    border-radius: 10px;
    min-height: 15vh;
    z-index: 100;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
    z-index: 101;
}

#CSData {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: flex-start;
	flex: auto;
}

.CSRow, .CSRowTitle {
	display: flex;
	flex-direction: row;
	justify-content: space-around;
	align-items: center;
}

.CSRowTitle {
	border-bottom: 1px solid lightgray;
}

.CSTitle{
	flex: 0.50;
	width: 10vw;
}

.CSValue{
	padding: 1vw;
}

.CSInputContainer {
    width: 5vw;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.CSInput{
    font-size: 15px;
    width: 2vw;
    margin-top: 1vh;
    margin-left: 0.5vw;
    margin-right: 0.5vw;
    margin-bottom: 1vh;
}

#CSButtons {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    padding-top: 4vh;
    padding: 0.5vw;
    padding-top: 1vw;
    margin-top: 2vh;
    background-color: lightgray;
}

#CSButtonCancel{
	margin-right: 5vw;
}`, "",{"version":3,"sources":["webpack://./src/project/modules/cellSelection/cellSelection.module.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;CAClB,OAAO;CACP,QAAQ;CACR,YAAY;CACZ,aAAa;CACb,UAAU;CACV,WAAW;CACX,+BAA+B;CAC/B,YAAY;AACb;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,yCAAyC;IACzC,YAAY;AAChB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,2BAA2B;CAC3B,uBAAuB;CACvB,UAAU;AACX;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,6BAA6B;CAC7B,mBAAmB;AACpB;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,UAAU;CACV,WAAW;AACZ;;AAEA;CACC,YAAY;AACb;;AAEA;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;CACC,iBAAiB;AAClB","sourcesContent":["#CSScreen {\r\n\tposition: absolute;\r\n\ttop:0px;\r\n\tleft:0px;\r\n\twidth: 100vw;\r\n\theight: 100vh;\r\n\tright: 0px;\r\n\tbottom: 0px;\r\n\tbackground-color: rgba(0,0,0,0);\r\n\tz-index: 100;\r\n}\r\n\r\n#CSContainer{\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    transform: translate(-50%, -50%);\r\n    display: flex;\r\n    flex-direction: column;\r\n    background-color: white;\r\n    border-radius: 10px;\r\n    min-height: 15vh;\r\n    z-index: 100;\r\n    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);\r\n    z-index: 101;\r\n}\r\n\r\n#CSData {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tjustify-content: flex-start;\r\n\talign-items: flex-start;\r\n\tflex: auto;\r\n}\r\n\r\n.CSRow, .CSRowTitle {\r\n\tdisplay: flex;\r\n\tflex-direction: row;\r\n\tjustify-content: space-around;\r\n\talign-items: center;\r\n}\r\n\r\n.CSRowTitle {\r\n\tborder-bottom: 1px solid lightgray;\r\n}\r\n\r\n.CSTitle{\r\n\tflex: 0.50;\r\n\twidth: 10vw;\r\n}\r\n\r\n.CSValue{\r\n\tpadding: 1vw;\r\n}\r\n\r\n.CSInputContainer {\r\n    width: 5vw;\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n\r\n.CSInput{\r\n    font-size: 15px;\r\n    width: 2vw;\r\n    margin-top: 1vh;\r\n    margin-left: 0.5vw;\r\n    margin-right: 0.5vw;\r\n    margin-bottom: 1vh;\r\n}\r\n\r\n#CSButtons {\r\n    display: flex;\r\n    flex-direction: row;\r\n    justify-content: space-around;\r\n    align-items: center;\r\n    padding-top: 4vh;\r\n    padding: 0.5vw;\r\n    padding-top: 1vw;\r\n    margin-top: 2vh;\r\n    background-color: lightgray;\r\n}\r\n\r\n#CSButtonCancel{\r\n\tmargin-right: 5vw;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
